export const inDescendingOrder = (arr: number[]) => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i + 1] > arr[i]) return false;
  }

  return true;
};
